import { ICmsContentService } from '../icms-content.service';
import { NICmsContentComponent } from '../interfaces/icms-content-component.interfaces';

export function ICmsComponent<T extends NICmsContentComponent.IComponent>(meta: Omit<NICmsContentComponent.IMeta, 'type'>) {
    return (type: NICmsContentComponent.ICmsComponentType<T>) => {
        const metaModified = Object.assign(meta, { type }) as NICmsContentComponent.IMeta;
        type.prototype._iCmsMeta = metaModified;
        ICmsContentService.registerComponent(metaModified);
        return type;
    };
}
